import React from 'react';
import { useSearchParams } from 'react-router-dom';

const API = import.meta.env.VITE_API_URL || '/api';

const ERROR_MESSAGES = {
  not_in_guild:  'You must be a member of the Discord server to access this portal.',
  banned:        'Your account has been suspended.',
  oauth_failed:  'Authentication failed. Please try again.',
  missing_code:  'Authentication was cancelled.',
};

export default function LoginPage() {
  const [params] = useSearchParams();
  const error    = params.get('error');

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 20,
    }}>
      <div style={{
        background: 'var(--bg2)', border: '1px solid var(--border)',
        borderRadius: 20, padding: '48px 40px', maxWidth: 400, width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🎫</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Support Portal</h1>
        <p style={{ color: 'var(--text2)', fontSize: 14, marginBottom: 32 }}>
          Sign in with your Discord account to access the ticket system.
          You must be a member of the server.
        </p>

        {error && (
          <div style={{
            background: '#2a1010', border: '1px solid #3a1818',
            borderRadius: 10, padding: '12px 16px', marginBottom: 24,
            color: 'var(--red)', fontSize: 13,
          }}>
            {ERROR_MESSAGES[error] || 'An error occurred. Please try again.'}
          </div>
        )}

        <a href={`${API}/auth/login`} style={{ display: 'block', textDecoration: 'none' }}>
          <button className="btn-primary" style={{
            width: '100%', padding: '12px 20px', fontSize: 15, borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          }}>
            <DiscordIcon />
            Sign in with Discord
          </button>
        </a>

        <p style={{ marginTop: 20, fontSize: 12, color: 'var(--text3)' }}>
          Only verified server members can access this portal.
        </p>
      </div>
    </div>
  );
}

function DiscordIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 71 55" fill="currentColor">
      <path d="M60.1 4.9A58.5 58.5 0 0 0 45.8.9a.2.2 0 0 0-.2.1 40.7 40.7 0 0 0-1.8 3.7 54 54 0 0 0-16.2 0A37.8 37.8 0 0 0 25.7 1a.2.2 0 0 0-.2-.1 58.4 58.4 0 0 0-14.3 4A.2.2 0 0 0 11 5C1.8 18.6-.9 31.9.3 45a.2.2 0 0 0 .1.1 58.8 58.8 0 0 0 17.7 9 .2.2 0 0 0 .2-.1 42 42 0 0 0 3.6-5.9.2.2 0 0 0-.1-.3 38.7 38.7 0 0 1-5.5-2.6.2.2 0 0 1 0-.4l1.1-.9a.2.2 0 0 1 .2 0c11.5 5.3 24 5.3 35.4 0a.2.2 0 0 1 .2 0l1.1.9a.2.2 0 0 1 0 .4 36.1 36.1 0 0 1-5.5 2.6.2.2 0 0 0-.1.3 47.1 47.1 0 0 0 3.6 5.9.2.2 0 0 0 .2.1 58.7 58.7 0 0 0 17.7-9 .2.2 0 0 0 .1-.1c1.5-15.5-2.5-28.8-10.6-40.7a.2.2 0 0 0-.1-.1zM23.7 37.3c-3.5 0-6.4-3.2-6.4-7.2s2.8-7.2 6.4-7.2c3.6 0 6.5 3.3 6.4 7.2 0 4-2.8 7.2-6.4 7.2zm23.6 0c-3.5 0-6.4-3.2-6.4-7.2s2.8-7.2 6.4-7.2c3.6 0 6.5 3.3 6.4 7.2 0 4-2.8 7.2-6.4 7.2z"/>
    </svg>
  );
}
